// VERSION: 1.0.0
// AUTHOR: AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import BusinessLoanDisbursementActionTypes from './business-loan-disbursement.types';
import {
	fetchBusinessLoanIndex,
	fetchFinanceBasaedAccountTypeDetails,
	createLoanDisbursement,
	fetchBasedOnBusinessLoanInfo,
	getBusinessList,
} from './business-loan-disbursement.service';

import {
	fetchBusinessLoanIndexSuccess,
	fetchBusinessLoanIndexFailure,
	fetchBusinessLoanIndexResponseChanged,
	fetchFinanceBaseAccountTypeSuccess,
	fetchFinanceBaseAccountTypeFailure,
	fetchFinanceBaseAccountTypeResponseChanged,
	businessLoanDisbursmentSuccess,
	businessLoanDisbursmentFailure,
	businessLoanDisbursmentResponseChanged,
	fetchBusinessLoanInfoSuccess,
	fetchBusinessLoanInfoFailure,
	fetchBusinessLoanInfoResponseChanged,
	getBusinessListSuccess,
	getBusinessListFailure,
	getBusinessListResponseChanged,
} from './business-loan-disbursement.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START FETCH BUSINESS LOAN INDEX DETAILS  ******************** */
export function* businessLoanIndexDetails({ payload }: any) {
	try {
		const key = 'FetchBusinessLoanIndexDetails';
		const jsonData = {
			BranchID: payload.branchID,
			CenterID: payload.centerID,
			BusinessID: payload.businessID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBusinessLoanIndex, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessLoanIndexFailure(responseData.data));
		} else {
			yield put(fetchBusinessLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessLoanIndexFailure(error));
	}
}

export function* resetBusinessLoanIndexeResponse() {
	yield put(fetchBusinessLoanIndexResponseChanged());
}

export function* onFetchBusinessLoanIndexDetails() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_START,
		businessLoanIndexDetails,
	);
}

export function* onBusinessLoanIndexResponseReset() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_RESPONSE_RESET,
		resetBusinessLoanIndexeResponse,
	);
}
/** *********************  END FETCH BUSINESS LOAN INDEX ******************** */

/** *********************  START FINANCE BASED ACCOUNT TYPE LIST  ******************** */
export function* fetchFinanceBasedAccountType({ payload }: any) {
	try {
		const key = 'GetFinanceBasedTypeListKey';
		const jsonData = {
			TransactionType: payload.typeOfTransaction,
			BranchID: payload.branchID,
			TransactionDate: payload.loanDisburementDate,
			DatabaseName: payload.databaseName,
			DisbursementCashType: 'Cash',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchFinanceBasaedAccountTypeDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFinanceBaseAccountTypeFailure(responseData.data));
		} else {
			yield put(fetchFinanceBaseAccountTypeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFinanceBaseAccountTypeFailure(error));
	}
}

export function* resetFinanceBasedAccountTypeResponse() {
	yield put(fetchFinanceBaseAccountTypeResponseChanged());
}

export function* onFetchFinanceBasedAccountTypeListDetails() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_START,
		fetchFinanceBasedAccountType,
	);
}

export function* onFinanceBasedAccountTypeResponseReset() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_RESET,
		resetFinanceBasedAccountTypeResponse,
	);
}
/** *********************  END FINANCE BASED ACCOUNT TYPE LIST ******************** */

/** *********************  START BUSINESS LOAN DISBURSEMENT  ******************** */
export function* businessLoanDisbursementCreate({ payload }: any) {
	try {
		const key = 'CreateBusinessLoanDisbursementKey';
		const jsonData = {
			LoanIndex: payload.loanIndexID,
			LoanIndexStatus: payload.loanStatus,
			LoanDisbursementArray: payload.loanDisbursementArray,
			MemberThrift: payload.memberThriftArray,
			TransactionType: payload.selectedInstrument,
			Loandisbursementdate: payload.loanDisburementDate,
			MeetupTime: payload.loanDisburementTime,
			ProductInvestors: payload.productInvestorArr,
			HOLoanIndex: '',
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createLoanDisbursement, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(businessLoanDisbursmentFailure(responseData.data));
		} else {
			yield put(businessLoanDisbursmentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(businessLoanDisbursmentFailure(error));
	}
}

export function* resetCreateBusinessLoanDisbursementResponse() {
	yield put(businessLoanDisbursmentResponseChanged());
}

export function* onCreateBusinessLoanDisbursement() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_START,
		businessLoanDisbursementCreate,
	);
}

export function* onCreateBusinessLoanDisbursementResponseReset() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_RESPONSE_RESET,
		resetCreateBusinessLoanDisbursementResponse,
	);
}
/** *********************  END BUSINESS LOAN DISBURSEMENT ******************** */

/** *********************  START FETCH VOUCHAR COUNT  ******************** */
export function* fetchBusinessLoanInfoFetch({ payload }: any) {
	try {
		const key = 'GetBusinessLoanInfoKey';
		const jsonData = {
			MemberID: payload.MemberID,
			LoanIndexID: payload.LoanIndexID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBasedOnBusinessLoanInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessLoanInfoFailure(responseData.data));
		} else {
			yield put(fetchBusinessLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessLoanInfoFailure(error));
	}
}

export function* resetBusinessLoanInfoResponse() {
	yield put(fetchBusinessLoanInfoResponseChanged());
}

export function* onFetchBusinessLoanInfo() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_START,
		fetchBusinessLoanInfoFetch,
	);
}

export function* onBusinessLoanInfoResponseReset() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_RESET,
		resetBusinessLoanInfoResponse,
	);
}
/** *********************  END FETCH VOUCHAR COUNT ******************** */

/** *********************  START GET BUSINESS LIST  ******************** */
export function* getBusinessListFetch({ payload }: any) {
	try {
		const { databaseName, companyID } = payload;
		const key = 'GetBusinessDataListKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBusinessList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessListFailure(responseData.data));
		} else {
			yield put(getBusinessListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessListFailure(error));
	}
}

export function* resetGetBusinessListResponse() {
	yield put(getBusinessListResponseChanged());
}

export function* onGetBusinessList() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_START,
		getBusinessListFetch,
	);
}

export function* onGetBusinessListResponseReset() {
	yield takeLatest(
		BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_RESPONSE_RESET,
		resetGetBusinessListResponse,
	);
}
/** *********************  END GET BUSINESS LIST  ******************** */

export function* businessLoanDisbursementSaga() {
	yield all([
		call(onFetchBusinessLoanIndexDetails),
		call(onBusinessLoanIndexResponseReset),
		call(onFetchFinanceBasedAccountTypeListDetails),
		call(onFinanceBasedAccountTypeResponseReset),
		call(onCreateBusinessLoanDisbursement),
		call(onCreateBusinessLoanDisbursementResponseReset),
		call(onFetchBusinessLoanInfo),
		call(onBusinessLoanInfoResponseReset),
		call(onGetBusinessList),
		call(onGetBusinessListResponseReset),
	]);
}
